import { Component, Inject, OnDestroy, OnInit, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { MPOS_CROSS } from 'src/defaultImages.js';
@Component({
  selector: 'app-mpos-filter',
  templateUrl: './mpos-filter.component.html',
  styleUrls: ['./mpos-filter.component.css'],
})
export class MposFilterComponent implements OnInit, OnDestroy {
  images = {
    MPOS_CROSS,
  };
  subscription: Subscription = new Subscription();
  selectedFilter: any; // Track the selected filter
  cloneModalData: any;
  translationText: any;
  constructor(
    private _dialogRef: MatDialogRef<any>,
    @Optional() @Inject(MAT_DIALOG_DATA) public modalData: any,
    private _translateService: TranslateService
  ) {}

  ngOnInit(): void {
    this.setTranslations();
    this.initProperty();
  }

  ngOnDestroy(): void {
    if(this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  private setTranslations(): void {
    this.subscription.add(
      this._translateService.get('MPOS_FILTERS').subscribe((translation) => {
        this.translationText = translation.MPOS_FILTERS || {};
      })
    );
  }

  private initProperty(): void {
    try {
      this.cloneModalData = JSON.parse(JSON.stringify(this.modalData) || '[]');
    } catch (error) {
      this.cloneModalData = this.modalData || [];
    }
    this.selectedFilter = this.cloneModalData[0];
  }

  cancelClicked() {
    this._dialogRef.close({
      status: 0,
      data: null,
      message: 'Filter not applied',
    });
  }

  // Event handler for when a filter name is clicked
  filterClicked(filter: any) {
    this.selectedFilter = filter;
  }

  updateChecked(option) {
    // Update the count for the selected filter
    this.updateFilterOptionCount(option);
  }

  resetSelectedOptions() {
    this.selectedFilter.options.forEach(
      (option) => (option.isSelected = false)
    );
    this.selectedFilter.selectedOptionsCount = 0;
  }

  applyFilters() {
    this._dialogRef.close({
      status: 1,
      data: this.cloneModalData,
      message: 'Filter applied',
    });
  }

  private updateFilterOptionCount(option) {
    // Find the filter to which the clicked option belongs
    const filter = this.cloneModalData.find(
      (filter) => filter.filterId === this.selectedFilter.filterId
    );
    if (filter) {
      // Update the count for the selected option
      filter.selectedOptionsCount = filter.options.filter(
        (opt) => opt.isSelected
      ).length;
    }
  }
}
